export const locale = {
    lang: 'it',
    data: {
        TRANSLATOR: {
            SELECT: 'Seleziona la lingua',
            CLICK_HERE: 'Clicca qui',
        },
        GENERIC_KEYWORD: {
            ACTIONS: 'AZIONI',
            STATUS: 'STATO',
            ACTIVE: 'Attivo',
            INACTIVE: 'Non attivo',
            NO_ITEMS_FOUND: 'Nessun elemento trovato',
            SAVE: 'Salva',
            CANCEL: 'Annulla',
            UPLOAD: 'Carica',
            CLOSE: 'Chiudi',
            REQUEST: 'Richiedi',
            BROWSE: 'Sfoglia',
            YEAR: 'Anno',
            MONTH: 'Mese',
            ADD: 'Aggiungi',
            EXPORT: 'Esporta',
        },
        DASHBOARD_BANKING_RELATIONSHIP_MANAGEMENT: {
            DOCUMENT_MANAGEMENT: {
                CONFIRMATION_MESSAGE_DELETE: 'Sei sicuro di voler cancellare il file "{{name}}" ?',
                CONFIRMATION_HEADER_DELETE: 'Elimina file',
                FILES_LOADED: 'File caricati',
                SIZE_FILE: 'Dimensioni',
                DRAG_AND_DROP: {
                    TITLE: 'Trascina qui i file da caricare',
                },
            },
            RISKS_CENTRAL: {
                LIST: {
                    TITLE: 'Centrale rischi',
                    SUB_TITLE:
                        'Richiedi la tua Centrale Rischi ed allegala in piattaforma per verificare la corretta segnalazione da parte degli Istituti di credito e la presenza di eventuali sconfinamenti',
                    YEAR: 'ANNO',
                    MONTH: 'MESE',
                    DOCUMENT: 'DOCUMENTO',
                    DOCUMENT_SIZE: 'DIMENSIONE DOC.',
                    REQUEST_CENTRAL_RISK: 'Richiedi CR',
                },
                REQUEST_CENTRAL_RISK_MODAL: {
                    TITLE: 'Guida alla richiesta centrale rischi',
                    DESCRIPTION:
                        "Cliccando il bottone RICHIEDI CR verrai reindirizzato al portale Banca D'Italia. Effettuando l'accesso con le credenziali SPID, sarà possibile richiedere la Centrale Rischi mediante invio al proprio indirizzo PEC. Una volta ricevuto il file potrai caricarlo sul tuo account cliccando sul bottone AGGIUNGI.",
                },
            },
            FINANCING_AND_LEASING: {
                TITLE: 'Affidamenti, finanziamenti e leasing',
                SUB_TITLE:
                    'Inserisci i tuoi rapporti di affidamento, finanziamenti e leasing accordati per tenere sotto controllo la tua situazione debitoria bancaria',
            },
        },
        AUTH: {
            GENERAL: {
                OR: 'Or',
                SUBMIT_BUTTON: 'Submit',
                NO_ACCOUNT: "Don't have an account?",
                SIGNUP_BUTTON: 'Registrati',
                FORGOT_BUTTON: 'Forgot Password',
                BACK_BUTTON: 'Back',
                PRIVACY: 'Privacy',
                LEGAL: 'Legal',
                CONTACT: 'Contact',
                SIGNIN: 'Accedi',
            },
            LOGIN: {
                TITLE: 'Login Account',
                BUTTON: 'Registrati',
            },
            FORGOT: {
                TITLE: 'Forgotten Password?',
                DESC: 'Scrivi la tua email per aggiornare la password',
                SUCCESS: 'Il tuo account è stato aggiornato correttamente.',
            },
            REGISTER: {
                TITLE: 'Sign Up',
                DESC: 'Enter your details to create your account',
                SUCCESS: 'Your account has been successfuly registered.',
            },
            INPUT: {
                EMAIL: 'Email',
                FULLNAME: 'Fullname',
                PASSWORD: 'Password',
                CONFIRM_PASSWORD: 'Confirm Password',
                USERNAME: 'Username',
            },
            VALIDATION: {
                INVALID: '{{name}} non valido',
                REQUIRED: '{{name}} is required',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'The login detail is incorrect',
                REQUIRED_FIELD: 'Required field',
                MIN_LENGTH_FIELD: 'Minimum field length:',
                MAX_LENGTH_FIELD: 'Maximum field length:',
                INVALID_FIELD: 'Field is not valid',
            },
        },
        primeng: {
            startsWith: 'Inizia con',
            contains: 'Contiene',
            notContains: 'Non contiene',
            endsWith: 'Finisce con',
            equals: 'Uguale',
            notEquals: 'Diverso',
            noFilter: 'Nessun filtro',
            lt: 'Minore di',
            lte: 'Minore o uguale a',
            gt: 'Maggiore di',
            gte: 'Maggiore o uguale a',
            is: '\u00C8',
            isNot: 'Non \u00E8',
            before: 'Prima di',
            after: 'Dopo',
            clear: 'Cancella',
            apply: 'Applica',
            matchAll: 'Match tutti',
            matchAny: 'Match qualunque',
            addRule: 'Aggiungi regola',
            removeRule: 'Rimuovi regola',
            accept: 'S\u00EC',
            reject: 'No',
            choose: 'Scegli',
            upload: 'Carica',
            cancel: 'Annulla',
            dayNames: [
                'Domenica',
                'Luned\u00EC',
                'Marted\u00EC',
                'Mercoled\u00EC',
                'Gioved\u00EC',
                'Venerd\u00EC',
                'Sabato',
            ],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
            monthNames: [
                'Gennaio',
                'Febbraio',
                'Marzo',
                'Aprile',
                'Maggio',
                'Giugno',
                'Luglio',
                'Agosto',
                'Settembre',
                'Ottobre',
                'Novembre',
                'Dicembre',
            ],
            monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
            today: 'Oggi',
            weekHeader: 'Sett',
            weak: 'Debole',
            medium: 'Medio',
            strong: 'Forte',
            passwordPrompt: 'Inserisci una password',
            emptyMessage: 'Nessun risultato trovato',
            emptyFilterMessage: 'Nessun risultato trovato',
        },
    },
};
